import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { subscribeToNotifications } from '../services/notificationService';
import 'react-toastify/dist/ReactToastify.css';

const Profile = () => {
  const { user, isAuthenticated, isLoading } = useAuth0();
  const localAuth = localStorage.getItem('auth') === 'true';
  const storedUser = (() => {
    try {
      return JSON.parse(localStorage.getItem('user')) || {};
    } catch (e) {
      return {};
    }
  })();
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    const initializeUser = async () => {
      const firstLoginPending = localStorage.getItem('firstLogin') !== 'false';
      if ((isAuthenticated || localAuth) && firstLoginPending) {
        setShowWelcome(true);
        localStorage.setItem('firstLogin', 'false');
        
        // Subscribe to notifications on first login
        try {
          await subscribeToNotifications();
          toast.success('Successfully subscribed to notifications');
        } catch (error) {
          console.error('Error subscribing to notifications:', error);
          toast.error('Failed to subscribe to notifications');
        }
        
        setTimeout(() => setShowWelcome(false), 5000);
      }
    };
    
    initializeUser();
  }, [isAuthenticated, localAuth]);

  if (isLoading && !localAuth) return <div>Loading...</div>;
  if (!isAuthenticated && !localAuth) return <div>Please log in to view your profile.</div>;

  const displayName = user?.name || user?.nickname || storedUser.name || storedUser.email || 'User';
  const displayEmail = user?.email || storedUser.email || 'Not provided';
  const displayNickname = user?.nickname || storedUser.username;
  const displayPicture = user?.picture || '/serventica-logo.svg';

  return (
    <div className="profile-page">
      {showWelcome && (
        <div className="profile-alert">
          👋 Hello {displayName}!
        </div>
      )}
      <h1 className="profile-title">Your Profile</h1>
      <div className="profile-details">
        <img src={displayPicture} alt="Profile" className="profile-avatar" />
        <div><strong>Name:</strong> {displayName}</div>
        <div><strong>Email:</strong> {displayEmail}</div>
        {displayNickname && <div><strong>Username:</strong> {displayNickname}</div>}
      </div>
    </div>
  );
};

export default Profile;